import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { ActionButton, Button, ModalDialog, Warning } from "@culturehq/components";
import client from "@culturehq/client";

import { errorService, parseQueryString, t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

const phrases = {
  subscribe: {
    action: t("Subscribe to email notifications for this event"),
    title: t("Subscribe?"),
    status: t("You are currently not receiving notifications for this event"),
    desc: t("Receive email updates for this event from the Host – such as changes to event time and location – and other details and reminders. Note: This will only subscribe you to emails for this particular event."),
    button: t("Subscribe")
  },
  unsubscribe: {
    action: t("Unsubscribe to email notifications for this event"),
    title: t("Unsubscribe?"),
    status: t("You are currently receiving notifications for this event"),
    desc: t("By unsubscribing, you will no longer receive email updates for this event from the Host – such as changes to event time and location – and other details and reminders. Note: This will only unsubscribe you from emails for this particular event. You can always re-subscribe should you change your mind."),
    button: t("Unsubscribe")
  }
};

class EventUnsubscribe extends Component {
  constructor(props) {
    super(props);

    // Should this modal automatically open?
    const { unsubscribe } = parseQueryString(props.location.search);

    this.state = {
      modalIsOpen: unsubscribe === "true",
      action: this.deriveActionFromProps(),
      isUserEventNotificationsEnabled: false,
      loading: true
    };
  }

  async componentDidMount() {
    try {
      const { emailSettings: { eventNotification } } = await client.getProfileEmailSettings();
      this.setState({ isUserEventNotificationsEnabled: eventNotification, loading: false });
    } catch (error) {
      errorService.error(error);
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    const { event: { id: eventId } } = this.props;

    if (prevProps.event.id !== eventId) {
      this.setState({
        action: this.deriveActionFromProps(),
        error: false,
        loading: false
      });
    }
  }

  handleModalOpen = () => {
    this.setState({ modalIsOpen: true });
  };

  handleModalClose = () => {
    this.setState({ modalIsOpen: false });
  };

  handleClick = async () => {
    const { event: { id: eventId } } = this.props;
    const { action: currentAction } = this.state;

    this.setState({ error: false, loading: "Submitting..." });

    try {
      if (currentAction === "unsubscribe") {
        await client.unsubscribeFromEventNotifications({ eventId });
      } else {
        await client.subscribeToEventNotifications({ eventId });
      }

      this.setState(({ action }) => ({
        action: action === "unsubscribe" ? "subscribe" : "unsubscribe",
        error: false,
        loading: false,
        modalIsOpen: false
      }));
    } catch (error) {
      this.setState({ error, loading: false });
    }
  };

  deriveActionFromProps() {
    const { event: { rsvpForUser } } = this.props;
    const { receiveNotifications } = rsvpForUser || {};

    return receiveNotifications ? "unsubscribe" : "subscribe";
  }

  render() {
    const { event: { rsvpForUser } } = this.props;
    const { modalIsOpen, error, loading, action } = this.state;

    const { responseType } = rsvpForUser || {};

    // Has the user confirmed their attendance? Users
    // must rsvp Invites/Yes/Interested to get notifications
    const isUserConfirmed = ["accepted", "invited", "interested"].indexOf(responseType) > -1;

    // Has the user enabled event notifications? Users
    // may disable all event notifications in their settings,
    // and thus won't get any updates on events.
    const { isUserEventNotificationsEnabled } = this.state;

    return (
      <>
        {isUserConfirmed && (
          <ActionButton icon="ios-bell" onClick={this.handleModalOpen}>
            {phrases[action].action}
          </ActionButton>
        )}
        {modalIsOpen && (
          <ChqModalDialog className="event-subsc" onClose={this.handleModalClose}>
            <ModalDialog.Heading>
              {phrases[action].title}
            </ModalDialog.Heading>
            <ModalDialog.Body>
              {error && <ErrorMessage error={error} />}

              {!isUserConfirmed && (
                <Warning>
                  <Trans>
                    You must be attending this event in order to edit your notifications.
                  </Trans>
                </Warning>
              )}

              {!isUserEventNotificationsEnabled && (
                <Warning>
                  <Trans>You have currently disabled all notifications from event hosts.</Trans>
                  <br /><br />
                  <Link to="/profile/settings/emails">
                    <Trans>Edit Email Notification Settings</Trans>
                  </Link>
                </Warning>
              )}

              {isUserConfirmed && isUserEventNotificationsEnabled && (
                <>
                  <p>{phrases[action].status}</p>
                  <p>{phrases[action].desc}</p>

                  <Button loading={loading} primary onClick={this.handleClick}>
                    {phrases[action].button}
                  </Button>
                </>
              )}
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default withRouter(EventUnsubscribe);
